import React from "react"
import HeroSection from 'components/pages/HeroSection'
import News from 'components/pages/News'
import About from 'components/pages/About'
import Ranking from 'components/pages/Ranking'
import Schedule from 'components/pages/Schedule'
import Tournaments from 'components/pages/Tournaments'
import Sns from 'components/pages/Sns'
import { Helmet } from "react-helmet-async";

const Home: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>AREA CUP</title>
        <meta property="og:title" content="AREA CUP" />
        <meta name="twitter:title" content="AREA CUP" />
      </Helmet>
      <HeroSection />
      <News />
      <About />
      <Ranking />
      <Schedule />
      <Tournaments />
      <Sns />
    </>
  )
}

export default Home
